module.exports = __webpack_public_path__ + "static/media/printer.159a9900.svg";